import React, { FC, useState } from 'react';

import {
  perfilVoebiz,
  account,
  categoryIcon,
  data,
  extract,
  fly,
  team,
  points,
  retroactive,
  accountOrange,
  categoryOrange,
  dataOrange,
  extractOrange,
  flyOrange,
  teamOrange,
  pointsOrange,
  retroactiveOrange,
  clubExtract,
  clubExtractOrange,
  club,
  clubOrange,
  vale,
  valeOrange,
} from 'utils/icons';

import { Tier } from 'services/api/tier/types';

import { getClassWithTheme } from 'helpers';

import { useTheme } from '../../containers/MyAccount';

export interface SidebarMobileProps {
  user: string;
  voeBizNumber: string;
  tier: string;
  isClubSmls: boolean;
  tierData: Tier;
  isValeMilhas: boolean;
}

interface SubmenuItem {
  href: string;
  title: string;
  id: string;
  iconOrange?: string;
  iconGrey?: string;
}

interface MenuItem {
  href?: string;
  title: string;
  id: string;
  iconOrange: string;
  iconGrey: string;
  submenu?: SubmenuItem[];
}

const SidebarMobile: FC<SidebarMobileProps> = ({ user, voeBizNumber, tierData, tier, isClubSmls, isValeMilhas }) => {
  const theme = useTheme();

  const isActiveMenu = (menu: string) => {
    const { pathname } = window.location;
    const splited = pathname.split('/');
    const lastPath = splited[splited.length - 1];
    return lastPath === menu ? 'active' : '';
  };

  const [isMenuVisible, setMenuVisible] = useState(true);

  const toggleMenuVisibility = () => {
    setMenuVisible(!isMenuVisible);
  };

  // Href constants
  const hrefMinhaConta = '/minha-conta';
  const hrefDadosDaConta = '/minha-conta/alterar-dados';
  const hrefMinhaCategoria = '/minha-conta/minha-categoria';
  const hrefExtratoVoebiz = '/minha-conta/extrato';
  const hrefExtratoClubeSmiles = '/extrato-clube-corporativo';
  const hrefMeusVoos = '/minha-conta/meus-voos';
  const hrefClubeSmiles = '/clube-corporativo';
  const hrefPontosRetroativos = '/minha-conta/solicitar-pontos';
  const hrefEquipe = '/beneficiarios';
  const hrefResgatarPontos = '/home';
  const hrefPremiarMilhasInst = '/gestao-premiar-milhas';
  const hrefPremiarMilhasGestao = '/gestao-premiar-milhas';

  // ID constants
  const idMinhaConta = 'vbz-my-category-my-account';
  const idDadosDaConta = 'vbz-my-category-my-data';
  const idMinhaCategoria = 'vbz-my-category-my-category';
  const idExtratoVoebiz = 'vbz-my-category-my-extract';
  const idExtratoClubeSmiles = 'vbz-club-extract';
  const idPontosRetroativos = 'vbz-my-category-retroactive';
  const idEquipe = 'vbz-my-category-my-team';
  const idResgatarPontos = 'vbz-my-category-my-points';
  const idMeusVoos = 'vbz-my-category-my-flights';
  const idClubeSmiles = 'vbz-club';
  const idPremiarMilhasInst = 'vbz-my-category-gift-miles-inst';
  const idPremiarMilhasGestao = 'vbz-my-category-gift-miles-client';

  // Title constants

  const titleMinhaConta = 'Minha conta';
  const titleDadosDaConta = 'Dados da conta';
  const titleMinhaCategoria = 'Minha categoria';
  const titleExtratoVoebiz = 'Extrato VoeBiz';
  const titleExtratoClubeSmiles = 'Extrato Clube Smiles';
  const titlePontosRetroativos = 'Pontos retroativos';
  const titleEquipe = 'Equipe';
  const titleResgatarPontos = 'Resgatar pontos';
  const titleMeusVoos = 'Meus voos';
  const titleClubeSmiles = 'Clube Smiles';
  const titlePremiarMilhasInst = 'Premiar milhas';
  const titlePremiarMilhasGestao = 'Premiar milhas';

  const isExclusive = tier.toLowerCase() === 'exclusive';

  const noClubNoMilesNoExclusive = !isClubSmls && !isValeMilhas;
  const clubNoMilesNoExclusive = isClubSmls && !isValeMilhas;
  const clubMilesNoExclusive = isClubSmls && isValeMilhas;
  const noClubMilesNoExclusive = !isClubSmls && isValeMilhas;

  const menuItems: { condition: boolean; items: MenuItem[] }[] = [
    {
      condition: noClubNoMilesNoExclusive,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },
        {
          href: hrefMeusVoos,
          id: idMeusVoos,
          title: titleMeusVoos,
          iconGrey: fly,
          iconOrange: flyOrange,
        },
        {
          href: hrefPontosRetroativos,
          id: idPontosRetroativos,
          title: titlePontosRetroativos,
          iconGrey: retroactive,
          iconOrange: retroactiveOrange,
        },
        {
          href: hrefEquipe,
          id: idEquipe,
          title: titleEquipe,
          iconGrey: team,
          iconOrange: teamOrange,
        },
        {
          href: hrefResgatarPontos,
          id: idResgatarPontos,
          title: titleResgatarPontos,
          iconGrey: points,
          iconOrange: pointsOrange,
        },
        {
          href: hrefPremiarMilhasInst,
          id: idPremiarMilhasInst,
          title: titlePremiarMilhasInst,
          iconGrey: vale,
          iconOrange: valeOrange,
        },
      ],
    },
    {
      condition: clubNoMilesNoExclusive,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefExtratoClubeSmiles,
          id: idExtratoClubeSmiles,
          title: titleExtratoClubeSmiles,
          iconGrey: clubExtract,
          iconOrange: clubExtractOrange,
        },
        {
          href: hrefPontosRetroativos,
          id: idPontosRetroativos,
          title: titlePontosRetroativos,
          iconGrey: retroactive,
          iconOrange: retroactiveOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },
        {
          href: hrefMeusVoos,
          id: idMeusVoos,
          title: titleMeusVoos,
          iconGrey: fly,
          iconOrange: flyOrange,
        },

        {
          href: hrefEquipe,
          id: idEquipe,
          title: titleEquipe,
          iconGrey: team,
          iconOrange: teamOrange,
        },
        {
          href: hrefResgatarPontos,
          id: idResgatarPontos,
          title: titleResgatarPontos,
          iconGrey: points,
          iconOrange: pointsOrange,
        },
        {
          href: hrefPremiarMilhasInst,
          id: idPremiarMilhasInst,
          title: titlePremiarMilhasInst,
          iconGrey: vale,
          iconOrange: valeOrange,
        },
      ],
    },
    {
      condition: clubMilesNoExclusive,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefPremiarMilhasGestao,
          id: idPremiarMilhasGestao,
          title: titlePremiarMilhasGestao,
          iconGrey: vale,
          iconOrange: valeOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },
        {
          href: hrefExtratoClubeSmiles,
          id: idExtratoClubeSmiles,
          title: titleExtratoClubeSmiles,
          iconGrey: clubExtract,
          iconOrange: clubExtractOrange,
        },
        {
          href: hrefPontosRetroativos,
          id: idPontosRetroativos,
          title: titlePontosRetroativos,
          iconGrey: retroactive,
          iconOrange: retroactiveOrange,
        },

        {
          href: hrefMeusVoos,
          id: idMeusVoos,
          title: titleMeusVoos,
          iconGrey: fly,
          iconOrange: flyOrange,
        },

        {
          href: hrefEquipe,
          id: idEquipe,
          title: titleEquipe,
          iconGrey: team,
          iconOrange: teamOrange,
        },
        {
          href: hrefResgatarPontos,
          id: idResgatarPontos,
          title: titleResgatarPontos,
          iconGrey: points,
          iconOrange: pointsOrange,
        },
      ],
    },
    {
      condition: noClubMilesNoExclusive,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefPremiarMilhasGestao,
          id: idPremiarMilhasGestao,
          title: titlePremiarMilhasGestao,
          iconGrey: vale,
          iconOrange: valeOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },

        {
          href: hrefPontosRetroativos,
          id: idPontosRetroativos,
          title: titlePontosRetroativos,
          iconGrey: retroactive,
          iconOrange: retroactiveOrange,
        },
        {
          href: hrefEquipe,
          id: idEquipe,
          title: titleEquipe,
          iconGrey: team,
          iconOrange: teamOrange,
        },
        {
          href: hrefResgatarPontos,
          id: idResgatarPontos,
          title: titleResgatarPontos,
          iconGrey: points,
          iconOrange: pointsOrange,
        },

        {
          href: hrefMeusVoos,
          id: idMeusVoos,
          title: titleMeusVoos,
          iconGrey: fly,
          iconOrange: flyOrange,
        },
      ],
    },
    {
      condition: isExclusive,
      items: [],
    },
  ];

  const renderMenuItem = (item: MenuItem) => (
    <li key={item.id} className={`my-account-sidebar-mobile__menu-item-container${isActiveMenu(item.id || '')}`}>
      <a href={item.href} className="my-account-sidebar-mobile__menu-item account-link">
        <i className="my-account-sidebar-mobile__icon--account-grey">
          <img src={item.iconGrey} alt={item.title} />
        </i>
        <i className="my-account-sidebar-mobile__icon--account-orange">
          <img src={item.iconOrange} alt={item.title} />
        </i>
        {item.title}
      </a>
    </li>
  );

  const renderMenu = () => {
    if (isExclusive) {
      return null;
    }
    return (
      <ul className="my-account-sidebar-mobile__menu">
        {menuItems.map((menu, index) => {
          if (menu.condition) {
            const otherItems = menu.items.filter((item) => item.id !== 'vbz-my-category-more');

            return (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={index}>{otherItems.map((item) => renderMenuItem(item))}</React.Fragment>
            );
          }
          return null;
        })}
      </ul>
    );
  };

  return (
    <div className={`my-account-sidebar-mobile ${tierData.tierList[0].name.toLowerCase().replace(' ', '-')}`}>
      <div className={getClassWithTheme('my-account-sidebar-mobile__header', theme)}>
        <div className="my-account-sidebar-mobile__header__top">
          <i className="my-account-sidebar-mobile__header__icon--perfil">
            <img src={perfilVoebiz} alt="perfil" />
          </i>
          <button
            className="my-account-sidebar-mobile__header__button"
            type="button"
            title="seta"
            onClick={toggleMenuVisibility}
          >
            {isMenuVisible ? (
              <i className="my-account-sidebar-mobile__icon--more-arrow">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.0091 11.3342C14.3358 11.0076 14.3358 10.4809 14.0091 10.1542L8.46914 4.61424C8.20914 4.35424 7.78914 4.35424 7.52914 4.61424L1.98914 10.1542C1.66247 10.4809 1.66247 11.0076 1.98914 11.3342C2.31581 11.6609 2.84247 11.6609 3.16914 11.3342L8.00247 6.50757L12.8358 11.3409C13.1558 11.6609 13.6891 11.6609 14.0091 11.3342Z"
                    fill="black"
                  />
                </svg>
              </i>
            ) : (
              <i className="my-account-sidebar-mobile__icon--more-arrow">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.99086 4.66576C1.66419 4.99243 1.66419 5.51909 1.99086 5.84576L7.53086 11.3858C7.79086 11.6458 8.21086 11.6458 8.47086 11.3858L14.0109 5.84576C14.3375 5.51909 14.3375 4.99243 14.0109 4.66576C13.6842 4.3391 13.1575 4.3391 12.8309 4.66576L7.99753 9.49243L3.16419 4.65909C2.84419 4.33909 2.31086 4.33909 1.99086 4.66576Z"
                    fill="black"
                  />
                </svg>
              </i>
            )}
          </button>
        </div>
        <h2 className="my-account-sidebar-mobile__header__client-name">{user}</h2>
        <p className="my-account-sidebar-mobile__header__client-id">Número VoeBiz: {voeBizNumber}</p>
      </div>

      {isMenuVisible && renderMenu()}
    </div>
  );
};

export default SidebarMobile;
